import axios from 'axios';
import API_BACKEND_URL from '@/API_URL/api_back_end.js';
import { collectClientDeviceInfo } from '@/utils/clientDeviceInfo';

const OPENED_SESSION_KEY = 'vueAppOpenedReported';

/**
 * Meldet „Vue-App im Browser geladen“ einmal pro Tab an Grafana (über Backend).
 * Fehler werden geschluckt — Logging darf die App nicht stören.
 */
export async function reportVueAppOpened() {
    try {
        if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem(OPENED_SESSION_KEY)) {
            return;
        }
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.setItem(OPENED_SESSION_KEY, '1');
        }

        let clientInfo = null;
        try {
            clientInfo = await collectClientDeviceInfo();
        } catch (err) {
            clientInfo = null;
        }

        await axios.post(`${API_BACKEND_URL}vue-app-opened`, {
            clientInfo,
            appVersion: process.env.VUE_APP_GIT_COMMIT || 'dev',
            path: typeof window !== 'undefined' ? window.location.pathname : '',
        });
    } catch (err) {
        // ignore
    }
}
